import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=33bb2d27"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=33bb2d27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports